import { render } from "./LbrxDiscountPopup.vue?vue&type=template&id=3a393837&scoped=true"
import script from "./LbrxDiscountPopup.vue?vue&type=script&lang=js"
export * from "./LbrxDiscountPopup.vue?vue&type=script&lang=js"

import "./LbrxDiscountPopup.vue?vue&type=style&index=0&id=3a393837&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a393837"]])

export default __exports__